import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['element']

  connect() {
    console.log('lol_controller')
    // console.log(this.elementTarget)
  }

  refresh() {
    console.log('refresh')
    window.location.reload()
  }
}
